import { Navigate } from 'react-router-dom'

import CreateProposalLayout from './CreateProposalLayout'

export default function MultisigCreateProposal() {
  return <CreateProposalLayout />
}

export function MultisigCreateProposalRedirect() {
  return <Navigate to='constructor' replace />
}

export { default as CreateProposalConstructor } from './CreateProposalConstructor'
export { default as CreateProposalManual } from './CreateProposalManual'
